import { AccidentAtlasCartesianChartConfig } from '../types/api'

export const CARTESIAN_CHART_PAGE_SIZE = 5

export function getCartesianCategoryCount(
  chart: AccidentAtlasCartesianChartConfig
): number {
  return chart.xAxis.categories.length
}

export function getCartesianChartPageCount(
  categoryCount: number,
  pageSize = CARTESIAN_CHART_PAGE_SIZE
): number {
  if (categoryCount <= 0) return 1
  return Math.ceil(categoryCount / pageSize)
}

export function shouldPaginateCartesianChart(
  categoryCount: number,
  compactChartLayout: boolean,
  pageSize = CARTESIAN_CHART_PAGE_SIZE
): boolean {
  return compactChartLayout && categoryCount > pageSize
}

export function getCartesianChartMax(
  chart: AccidentAtlasCartesianChartConfig
): number {
  let max = 0

  for (const series of chart.series) {
    for (const value of series.data) {
      if (value > max) max = value
    }
  }

  return max
}

export function sliceCartesianChart(
  chart: AccidentAtlasCartesianChartConfig,
  page: number,
  pageSize = CARTESIAN_CHART_PAGE_SIZE
): {
  chart: AccidentAtlasCartesianChartConfig
  startIndex: number
} {
  const startIndex = page * pageSize
  const endIndex = startIndex + pageSize

  return {
    startIndex,
    chart: {
      ...chart,
      xAxis: {
        ...chart.xAxis,
        categories: chart.xAxis.categories.slice(startIndex, endIndex),
      },
      series: chart.series.map((series) => ({
        ...series,
        data: series.data.slice(startIndex, endIndex),
      })),
    },
  }
}
